import { render, staticRenderFns } from "./DetailsSummary.vue?vue&type=template&id=6935fb5f&"
import script from "./detailsSummary.js?vue&type=script&lang=js&"
export * from "./detailsSummary.js?vue&type=script&lang=js&"
import style0 from "./DetailsSummary.vue?vue&type=style&index=0&id=6935fb5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports